import React from 'react';
import * as PromoBannerStyle from "./promoBanner.module.scss"
import {StaticImage} from "gatsby-plugin-image";
import Countdown from "../countdown/countdown";
import {Link} from "gatsby";

function PromoBanner({page}) {
  return (
    <div className={PromoBannerStyle.promoBannerWrapper}>
      <div
        className={`${PromoBannerStyle.promoBannerWrapper__shapeLeft} ${PromoBannerStyle.promoBannerWrapper__shapeLeft_left}`}>
        <StaticImage src="../../../images/promo/spring-cal.png" formats={["auto", "webp", "avif"]}
                     quality={100} alt="Promo Shape" placeholder="none" loading="eager"
                     className={`${PromoBannerStyle.promoBannerWrapper__shapeLeft__deskImg} ${PromoBannerStyle[`promoBannerWrapper__shapeLeft__deskImg_${page}`]}`}
        />
      </div>
      <div
        className={`${PromoBannerStyle.promoBannerWrapper__shapeRight} ${PromoBannerStyle.promoBannerWrapper__shapeRight_right}`}>
        <StaticImage src="../../../images/promo/spring-clock.png" formats={["auto", "webp", "avif"]}
                     quality={100} alt="Promo shape" placeholder="none" loading="eager"
                     className={`${PromoBannerStyle.promoBannerWrapper__shapeRight__deskImg} ${PromoBannerStyle[`promoBannerWrapper__shapeRight__deskImg_${page}`]}`}
        />
      </div>
      <div className={PromoBannerStyle.promoBannerWrapper__shapeTablet}>
        <StaticImage src="../../../images/promo/spring-cal-tablet.png" formats={["auto", "webp", "avif"]} quality={100}
                     alt="Promo shape" placeholder="none" loading="eager"/>
      </div>
      <div className={PromoBannerStyle.promoBannerWrapper__promoBanner}>

          <div className={PromoBannerStyle.promoBannerWrapper__promoBanner__promoTitle}>
            <div className={PromoBannerStyle.promoBannerWrapper__promoBanner__titleText}>
         <span className={PromoBannerStyle.promoBannerWrapper__promoBanner__titleMain}>
         Spring Into Savings
         </span>
              <span className={PromoBannerStyle.promoBannerWrapper__promoBanner__discount}>
         <span className={PromoBannerStyle.discountTop}>40%off</span>
         <span className={PromoBannerStyle.discountBottom}>on all plans</span>
         </span>
            </div>
          </div>




        <div className={PromoBannerStyle.promoBannerWrapper__promoBanner__couponWrapper}>
          <span className={PromoBannerStyle.promoBannerWrapper__promoBanner__couponWrapper__couponTitle}>
            with coupon code
          </span>
          <span className={PromoBannerStyle.promoBannerWrapper__promoBanner__couponWrapper__coupon}>
            BLOOM40
          </span>
        </div>
        <Countdown/>
        {page !== 'pricing' &&
          <Link to="/pricing/">
            Grab the deal
          </Link>
        }
      </div>
      <div className={PromoBannerStyle.promoBannerWrapper__couponWrapperRes}>
     <span className={PromoBannerStyle.promoBannerWrapper__promoBanner__couponWrapper__couponTitle}>
            with coupon code
          </span>
        <span className={PromoBannerStyle.promoBannerWrapper__promoBanner__couponWrapper__coupon}>
            BLOOM40
          </span>
      </div>
    </div>
  );
}

export default PromoBanner;